import React from 'react';

const IconCoins = props => {
  const { className } = props;
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <g fill="none" stroke="#115a36" strokeLinecap="round" strokeLinejoin="round">
        <g transform="scale(3.42857)">
          <ellipse cx={9} cy={5.5} rx={4.5} ry={2} />
          <path d="M4.5 5.5v6c0 1.1 2 2 4.5 2s4.5-.9 4.5-2v-6" />
          <path d="M13.5 8.5c0 1.1-2 2-4.5 2s-4.5-.9-4.5-2" />
        </g>
        <path
          d="M30.514 5.143a23.211 23.211 0 00-13.371-3.429C8.606 1.714 1.714 4.8 1.714 8.571c0 2.023 1.989 3.84 5.143 5.143"
          strokeWidth={3.42857}
        />
        <path
          d="M6.857 34.286c-3.154-1.303-5.143-3.12-5.143-5.143V8.57M6.857 24c-3.154-1.303-5.143-3.12-5.143-5.143"
          strokeWidth={3.42857}
        />
      </g>
    </svg>
  );
};

export default IconCoins;
